import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import clsx from "clsx";
import { Formik } from "formik";
import {
  Button,
  Card,
  CardHeader,
  CardContent,
  Grid,
  TextField,
  makeStyles,
} from "@material-ui/core";
import Autocomplete from '@material-ui/lab/Autocomplete';

import { SIREN_CONFIG } from "config.js";
import { getRoomTypes, getRoomTypeRow } from 'utils/RoomType';
import { loadCaregiverList, getCaregiverValue, getCaregiverTelNo } from "utils/LoadConfiguration";
import {useSelector} from 'react-redux';
import { FormattedMessage, useIntl } from "react-intl";


const RoomAddForm = (props) => {
  const { className, history, ...rest } = props;
  const classes = useStyles();
  const {formatMessage} = useIntl();

  const [roomTypes, setRoomTypes] = useState([]);
  const [selectedRoomType, setSelectedRoomType] = useState('');
  const [caregiverList, setCaregiverList] = useState([]);
	// const [selectedCaregiver1_Id, setSelectedCaregiver1_Id] = useState('');
  // const [selectedCaregiver2_Id, setSelectedCaregiver2_Id] = useState('');
  const facility_id = useSelector((store) => store.user.facility_id);

  const handleSubmit = (event, values) => {
    event.preventDefault();

    fetch(`${SIREN_CONFIG.HOSTNAME}/room/addRoom`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        facility_id: facility_id,
        roomId: values.roomId,
        roomName: values.roomName,
        roomType: selectedRoomType,
        // caregiver1_id: selectedCaregiver1_Id,
        // caregiver2_id: selectedCaregiver2_Id,
      }),
    })
      .then((response) => {
        return response.json();
      })
      .then((responseData) => {
        if (responseData.resultCode === "000") {
          alert(formatMessage({id:'room_add_successful'}));

          setTimeout(() => {
            history.goBack();
          }, 500);
        } else {
          //에러
          console.log(responseData.message);
          alert(`${formatMessage({id:'room_add_failed'})}\n${responseData.resultMessage}\n${responseData.message}`);
        }
      })
      .catch((error) => {
        console.error(error);
        alert(`${formatMessage({id:'room_add_failed'})}\n${responseData.message}`);
      });
  };

  const handleBack = () => {
    history.goBack();
  };

  useEffect(() => {

    async function loadCaregiverInfo(){
      setCaregiverList( await loadCaregiverList(facility_id ) );
    }
    loadCaregiverInfo();

    setRoomTypes(getRoomTypes());
  }, []);


  return (
    <Formik
      initialValues={{
        roomId: "",
        roomName: "",
        roomType: "",
        // caregiver1_id: "",
        // caregiver2_id: "",
      }}
    >
      {({
        errors,
        handleBlur,
        handleChange,
        isSubmitting,
        touched,
        values,
      }) => {
          return (
            <form
              className={clsx(classes.root, className)}
              onSubmit={(e) => handleSubmit(e, values)}
            >
              <Card>
                <CardHeader
                  className={classes.card_header}
                  title={formatMessage({id:'add_room'})}
                  titleTypographyProps={{ align: "center", color: 'inherit', variant: 'h4' }} />

                <CardContent>
                  <Grid container spacing={2}>
                    <Grid item md={4} xs={12}>
                      <TextField
                        error={Boolean(touched.roomId && errors.roomId)}
                        fullWidth
                        helperText={touched.roomId && errors.roomId}
                        label={formatMessage({id:'room_id'})}
                        name="roomId"
                        onBlur={handleBlur}
                        onChange={handleChange}
                        required
                        value={values.roomId}
                        variant="outlined"
                        inputProps={{ maxLength: 24 }} />
                    </Grid>


                    <Grid item md={4} xs={12}>
                      <TextField
                        error={Boolean(touched.roomName && errors.roomName)}
                        fullWidth
                        helperText={touched.roomName && errors.roomName}
                        label={formatMessage({id:'room_name_label'})}
                        name="roomName"
                        onBlur={handleBlur}
                        onChange={handleChange}
                        required
                        value={values.roomName}
                        variant="outlined"
                        inputProps={{ maxLength: 100 }} />
                    </Grid>


                    <Grid item md={4} xs={12}>
                      <Autocomplete
                        id="roomType"
                        // style={{ width: 300 }}
                        options={roomTypes}
                        autoHighlight
                        getOptionLabel={(option) => (option.roomTypeLabel ? option.roomTypeLabel : "")}
                        getOptionSelected={(option, value) => option.roomTypeLabel === value.roomTypeLabel}
                        value={getRoomTypeRow(selectedRoomType)}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label={formatMessage({id:'select_room_type'})}
                            variant="outlined"
                            fullWidth
                            inputProps={{
                              ...params.inputProps,
                              autoComplete: 'new-password'
                            }} />
                        )}

                        onChange={(event, newValue) => {
                          if (newValue && newValue.roomTypeCode) {
                            setSelectedRoomType(newValue.roomTypeCode);
                            console.log(newValue);
                          }
                        } } />
                    </Grid>


                    {/* <Grid container item spacing={2} >
              <Grid item md={4} xs={12} >

                <Autocomplete
                  id="caregiver1"
                  options={caregiverList}
                  classes={{ option: classes.options, }}
                  autoHighlight
                  getOptionLabel={(option) => option.caregiverName ? option.caregiverName : ""}
                  getOptionSelected={(option, value) => option.caregiverName === value.caregiverName}
                  value={getCaregiverValue(selectedCaregiver1_Id)}

                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="담당요양사1를 선택해 주세요"
                      variant="outlined"
                      fullWidth
                      inputProps={{
                        ...params.inputProps,
                        autoComplete: 'new-password', // disable autocomplete and autofill
                      }}
                    />
                  )}

                  onChange={(event, newValue) => {
                    if (newValue && newValue.caregiverId) {
                      setSelectedCaregiver1_Id(newValue.caregiverId);
                      // console.log('newValue: ', newValue);
                      // values.caregiver1_telno = newValue.caregiverTelNo;
                    }
                  }}
                />

              </Grid>

              <Grid item md={4} xs={12}>
                <TextField
                  InputLabelProps={{ shrink: true }}
                  disabled
                  fullWidth
                  label="담당요양사1 전화번호"
                  name="caregiver1_telno"
                  value={getCaregiverTelNo(selectedCaregiver1_Id)}
                  variant="outlined"
                  inputProps={{ maxLength: 20 }}
                />
              </Grid>
            </Grid>


            <Grid container item spacing={2} >
              <Grid item md={4} xs={12} >

                <Autocomplete
                  id="caregiver2"
                  options={caregiverList}
                  classes={{ option: classes.options, }}
                  autoHighlight
                  getOptionLabel={(option) => option.caregiverName ? option.caregiverName : ""}
                  getOptionSelected={(option, value) => option.caregiverName === value.caregiverName}
                  value={getCaregiverValue(selectedCaregiver2_Id)}

                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="담당요양사2를 선택해 주세요"
                      variant="outlined"
                      fullWidth
                      inputProps={{
                        ...params.inputProps,
                        autoComplete: 'new-password', // disable autocomplete and autofill
                      }}
                    />
                  )}

                  onChange={(event, newValue) => {
                    if (newValue && newValue.caregiverId) {
                      setSelectedCaregiver2_Id(newValue.caregiverId);
                      // console.log('newValue: ', newValue);
                      // values.caregiver1_telno = newValue.caregiverTelNo;
                    }
                  }}
                />

              </Grid>

              <Grid item md={4} xs={12}>
                <TextField
                  InputLabelProps={{ shrink: true }}
                  disabled
                  fullWidth
                  label="담당요양사2 전화번호"
                  name="caregiver2_telno"
                  value={getCaregiverTelNo(selectedCaregiver2_Id)}
                  variant="outlined"
                  inputProps={{ maxLength: 20 }}
                />
              </Grid>
            </Grid> */}

                  </Grid>

                  <Grid item className={classes.action}>
                    <Button
                      variant="contained"
                      color="primary"
                      type="submit"
                      size="large"
                      disabled={isSubmitting}
                      className={classes.action}
                    >
                      <FormattedMessage id="add" />
                    </Button>

                    <Button
                      variant="outlined"
                      size="large"
                      onClick={handleBack}
                      className={classes.action}
                    >
                      <FormattedMessage id="cancel" />
                    </Button>
                  </Grid>
                </CardContent>

              </Card>
            </form>
          );
        }}
    </Formik>
  );
};

RoomAddForm.propTypes = {
  className: PropTypes.string,
  history: PropTypes.object,
};

export default RoomAddForm;


const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
  content: {
    marginTop: theme.spacing(2),
  },
  action: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
    "& + &": {
      marginLeft: theme.spacing(1),
    },
  },
  card_header: {
    color: theme.palette.primary.contrastText,
    backgroundColor: theme.palette.primary.main,
  },
}));

